import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Lesson } from './lesson.model';
import { MessageNotification } from './lesson.message.model';
import { LessonPopupService } from './lesson-popup.service';
import { LessonService } from './lesson.service';

@Component({
    selector: 'jhi-lesson-send-notification-dialog',
    templateUrl: './lesson-send-notification-dialog.component.html'
})
export class LessonSendNotificationDialogComponent {

    lesson: Lesson;
    subject: string;
    body: string;
    messageSent: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private lessonService: LessonService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['lesson', 'lessonStatus', 'reservation', 'reservationStatus', 'student', 'classType']);
        this.messageSent = false;
    }

    clear() {
        this.messageSent = false;
        this.activeModal.dismiss('cancel');
    }

    sendMessage() {
        this.lessonService.sendMessage(
            new MessageNotification (this.subject, this.body, this.lesson.id, 'EMAIL'))
                          .subscribe(result => {
                            this.messageSent = true;
                           });
    }
}

@Component({
    selector: 'jhi-lesson-send-notification-popup',
    template: ''
})
export class LessonSendNotificationPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lessonPopupService: LessonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.lessonPopupService
                .open(LessonSendNotificationDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-send-notification-dialog.component.ts